import page from 'page';

import * as dashboard from 'modules/dashboard';
import * as catalog from 'modules/catalog';
import * as messaging from 'modules/messaging';
import * as tip from 'modules/tip';
import * as memo from 'modules/memo';
import * as product from 'modules/product';
import * as funnel from 'modules/funnel';
import * as admin from 'modules/admin';
import * as news from 'modules/news';
import * as pco from 'modules/pco';
import * as saasUsers from 'modules/saas/users';
import * as saasProducts from 'modules/saas/products';
import * as saasCustomers from 'modules/saas/customers';
import * as saasCustomerUsers from 'modules/saas/customers/users';
import * as saasSites from 'modules/saas/sites';
import * as saasCases from 'modules/saas/pco/cases';
import * as saasOrganize from 'modules/saas/pco/cases/organize';
import * as saasForcedInvoicesOrganize from 'modules/saas/pco/cases/forced-invoices-organize';
import * as saasInterventions from 'modules/saas/pco/interventions';
import * as saasInterventionErrors from 'modules/saas/pco/interventions/errors';
import * as saasEstimates from 'modules/saas/estimates';
import * as saasInvoices from 'modules/saas/invoices';
import * as saasSettings from 'modules/saas/settings';
import * as saasEntity from 'modules/saas/entity';
import * as saasExports from 'modules/saas/exports';
import * as saasZones from 'modules/saas/pco/zones';
import * as saasPlots from 'modules/saas/plots';
import * as saasDemandTemplates from 'modules/saas/demands/templates';
import * as saasFastDemands from 'modules/saas/demands/fast';
import * as customerDashboard from 'modules/customer/index';
import * as customerInvoices from 'modules/customer/invoices';
import * as customerReports from 'modules/customer/reports';
import * as customerAASTReports from 'modules/customer/aast-reports';
import * as customerDocuments from 'modules/customer/documents';
import * as saasTemplateSettings from 'modules/saas/settings/templates/edit';
import * as saasCaseCreation from 'modules/saas/pco/cases-creation';
import * as saasAastCaseCreation from 'modules/saas/aast/cases-creation';
import * as saasAastCaseStudy from 'modules/saas/aast/case-study';
import * as saasAastCaseContract from 'modules/saas/aast/case-contract';
import * as saasAastCaseContractOrganize from 'modules/saas/aast/case-contract/organize';
import * as saasAastCaseContractRenew from 'modules/saas/aast/case-contract/renew';
import * as saasAastIntervention from 'modules/saas/aast/interventions';
import * as saasAastCaseReports from 'modules/saas/aast/case-report';
import saasAastCaseList from 'modules/saas/aast/cases/list';
import saasAastCaseListOngoing from 'modules/saas/aast/cases/list-ongoing';
import saasAastCaseListToPlan from 'modules/saas/aast/cases/list-toplan';
import saasAastCaseListToOrganize from 'modules/saas/aast/cases/list-toorganize';
import saasAastCaseListToRenew from 'modules/saas/aast/cases/list-torenew';
import saasAastCustomerCaseList from 'modules/saas/aast/cases/customer-list';
import saasAastCustomerSiteList from 'modules/saas/aast/cases/site-list';
import saasAastInterventionNotExecuted from 'modules/saas/aast/interventions/list-notexecuted';
import saasAastInterventionNotValidated from 'modules/saas/aast/interventions/list-notvalidated';
import saasAastInterventionInError from 'modules/saas/aast/interventions/list-inerror';
import * as saasAastStock from 'modules/saas/aast/product';
import * as saasAASTZones from 'modules/saas/aast/zones';

export default function hook() {
  // Back Office
  page('/catalogs/:code', catalog.edit);
  page('/messaging', messaging.index);
  page('/funnels/:id', funnel.edit);
  page('/products/:id', product.edit);
  page('/tips/:id', tip.edit);
  page('/memos/:id', memo.edit);
  page('/admin', admin.index);
  page('/pco/entities/from-user', pco.create);
  page('/pco/entities/:id', pco.edit);
  page('/admin/users/:id', admin.user);
  page('/admin/mailing/pco', admin.mailing);
  page('/admin/access', admin.access);
  page('/admin/settings', admin.exports);
  page('/news/:id', news.index);
  page('/news/new', news.index);

  // SAAS
  page('/pco-manager/dashboard', dashboard.pco);
  page('/pco-manager/users', saasUsers.list);
  page('/pco-manager/users/new', saasUsers.create);
  page('/pco-manager/users/:id/vacations', saasUsers.vacations);
  page('/pco-manager/users/:id/end-point', saasUsers.editPoint);
  page('/pco-manager/users/:id/start-point', saasUsers.editPoint);
  page('/pco-manager/users/:id', saasUsers.bindDetail);
  page('/pco-manager/products', saasProducts.list);
  page('/pco-manager/products/new', saasProducts.create);
  page('/pco-manager/products/:id', saasProducts.edit);
  page('/pco-manager/customers', saasCustomers.list);
  page('/pco-manager/customers/new', saasCustomers.create);
  page('/pco-manager/customers/new/company', saasCustomers.create);
  page('/pco-manager/customers/new/particular', saasCustomers.createParticular);
  page('/pco-manager/customers/:id', saasCustomers.edit);
  page('/pco-manager/customers/import/panel', saasCustomers.importer);
  page('/pco-manager/customers/import/verify', saasCustomers.importer);
  page('/pco-manager/customers/:id/users', saasCustomerUsers.list);
  page('/pco-manager/customers/:id/users/new', saasCustomerUsers.create);
  page('/pco-manager/customer/users/:id', saasCustomerUsers.edit);
  page('/pco-manager/customers/:id/sites', saasSites.list);
  page('/pco-manager/customers/:id/sites/new', saasSites.create);
  page('/pco-manager/customers/:id/cases', saasCases.byCustomer);
  page(
    '/pco-manager/customers/:id/interventions',
    saasInterventions.byCustomer
  );
  page('/pco-manager/customers/:id/invoices', saasInvoices.byCustomer);
  page('/pco-manager/sites/:id', saasSites.edit);
  page('/pco-manager/sites/:id/cases', saasCases.bySite);
  page('/pco-manager/sites/:id/zones', saasZones.bySite);
  page('/pco-manager/sites/:id/interventions', saasInterventions.bySite);
  page('/pco-manager/zones/:id', saasZones.informations);
  page('/pco-manager/cases/:id/zones', saasZones.list);
  page('/pco-manager/sites/:id/plots', saasPlots.list);
  page('/pco-manager/zones/:id/plan', saasZones.plan);
  page('/pco-manager/zones/:id/plots', saasPlots.list);
  page('/pco-manager/zones/points/:id', saasPlots.list);
  page('/pco-manager/cases', saasCases.byEntity);
  page('/pco-manager/customers/:id/cases/new', saasCases.create);
  page('/pco-manager/cases/:id/amendment', saasCases.create);
  page('/pco-manager/workflow/cases/study', saasCases.byEntityStudy);
  page('/pco-manager/workflow/cases/toorganize', saasCases.byEntityToOrganize);
  page('/pco-manager/cases/:id', saasCases.edit);
  page('/pco-manager/cases/:id/organize', saasOrganize.edit);
  page(
    '/pco-manager/cases/:id/organize-force-invoice',
    saasForcedInvoicesOrganize.edit
  );
  page('/pco-manager/cases/:id/interventions', saasInterventions.byCase);
  page('/pco-manager/cases/:id/estimates', saasCases.estimateList);
  page('/pco-manager/cases/:id/estimates/new', saasEstimates.detail);
  page('/pco-manager/cases/:id/invoices', saasInvoices.byCase);
  page('/pco-manager/cases/:id/invoices/new', saasInvoices.detail);
  page('/pco-manager/aast/cases/:id/invoices', saasInvoices.byAASTCase);
  page('/pco-manager/aast/cases/:id/invoices/new', saasInvoices.detail);
  page('/pco-manager/cases-creation/:id', saasCaseCreation.handleStep);
  page('/pco-manager/invoices', saasInvoices.byEntity);
  page('/pco-manager/invoices/toprepare', saasInvoices.byEntityToPrepare);
  page('/pco-manager/invoices/issuable', saasInvoices.byEntityToIssue);
  page('/pco-manager/invoices/toissue', saasInvoices.byEntityToIssue);
  page('/pco-manager/invoices/topay', saasInvoices.byEntityWaiting);
  page('/pco-manager/invoices/late', saasInvoices.byEntityLate);
  page(
    '/pco-manager/interventions/generality/:id',
    saasInterventions.generality
  );
  page(
    '/pco-manager/workflow/interventions/toplan',
    saasInterventions.byEntityToPlan
  );
  page(
    '/pco-manager/workflow/interventions/tovalidate',
    saasInterventions.byEntityToValidate
  );
  page(
    '/pco-manager/workflow/interventions/notexecuted',
    saasInterventions.byEntityNotExecuted
  );
  page('/pco-manager/interventions/rat/:id', saasInterventions.task);
  page('/pco-manager/interventions/insect/:id', saasInterventions.task);
  page('/pco-manager/interventions/disinfection/:id', saasInterventions.task);
  page('/pco-manager/interventions/other-pests/:id', saasInterventions.task);
  page('/pco-manager/interventions/annex1/:id', saasInterventions.task);
  page('/pco-manager/interventions/annex2/:id', saasInterventions.task);
  page(
    '/pco-manager/interventions/observation/:id',
    saasInterventions.observation
  );
  page(
    '/pco-manager/interventions/validation/:id',
    saasInterventions.validation
  );
  page(
    '/pco-manager/interventions/:id/errors/products',
    saasInterventionErrors.products
  );
  page(
    '/pco-manager/workflow/estimates/toprepare',
    saasEstimates.listToPrepare
  );
  page('/pco-manager/workflow/estimates/waiting', saasEstimates.listWaiting);
  page('/pco-manager/estimates/:id', saasEstimates.detail);
  page('/pco-manager/estimates/:id/duplicate', saasEstimates.detail);
  page('/pco-manager/invoices/:id', saasInvoices.detail);
  page('/pco-manager/invoices/:id/duplicate', saasInvoices.detail);
  page('/pco-manager/invoices/:id/asset', saasInvoices.detail);
  page('/pco-manager/invoices/:id/payments', saasInvoices.payments);
  page('/pco-manager/invoices/:id/comments', saasInvoices.comments);
  page('/pco-manager/invoices/:id/assets', saasInvoices.assets);
  page('/pco-manager/settings', saasSettings.index);
  page('/pco-manager/settings/invoice', saasSettings.index);
  page('/pco-manager/settings/estimate', saasSettings.index);
  page('/pco-manager/settings/tva/list', saasSettings.tva);
  page('/pco-manager/entity', saasEntity.index);
  page('/pco-manager/exports', saasExports.index);
  page('/pco-manager/cases/:id/contract', saasCases.contract);
  page('/pco-manager/demands/templates', saasDemandTemplates.list);
  page('/pco-manager/demands/templates/news', saasDemandTemplates.create);
  page('/pco-manager/demands/templates/:id', saasDemandTemplates.edit);
  page('/pco-manager/demands/fast/:id', saasFastDemands.create);
  page('/pco-manager/settings/lines', saasSettings.lines);
  page(
    '/pco-manager/settings/annex-activities',
    saasSettings.annexTemplateList
  );
  page('/pco-manager/settings/annex-activities/:id', saasTemplateSettings.edit);
  page('/pco-manager/settings/documents', saasSettings.documents);
  page('/pco-manager/settings/other-tasks', saasSettings.otherPestsEdit);
  page('/pco-manager/settings/rat', saasSettings.ratEdit);
  page('/pco-manager/settings/insect', saasSettings.insectEdit);

  // AAST
  page('/pco-manager/aast/cases-creation/:id', saasAastCaseCreation.handleStep);
  page('/pco-manager/aast/cases/:id/study', saasAastCaseStudy.bind);
  page(
    '/pco-manager/aast/cases/:id/interventions',
    saasAastIntervention.byAastCase
  );
  page('/pco-manager/aast/cases/interventions/:id', saasAastIntervention.bind);
  page('/pco-manager/aast/cases/:id/contract', saasAastCaseContract.contract);
  page(
    '/pco-manager/aast/cases/:id/contract/organize',
    saasAastCaseContractOrganize.bind
  );
  page(
    '/pco-manager/aast/cases/:id/contract/renew',
    saasAastCaseContractRenew.bind
  );
  page('/pco-manager/aast/cases', saasAastCaseList);
  page('/pco-manager/aast/cases/import/panel', saasCustomers.importer);
  page('/pco-manager/aast/cases/import/verify', saasCustomers.importer);
  page('/pco-manager/aast/cases-ongoing', saasAastCaseListOngoing);
  page('/pco-manager/aast/cases-toplan', saasAastCaseListToPlan);
  page('/pco-manager/aast/cases-toorganize', saasAastCaseListToOrganize);
  page('/pco-manager/aast/cases-torenew', saasAastCaseListToRenew);

  page(
    '/pco-manager/aast/interventions/notexecuted',
    saasAastInterventionNotExecuted
  );
  page(
    '/pco-manager/aast/interventions/notvalidated',
    saasAastInterventionNotValidated
  );
  page('/pco-manager/aast/interventions/error', saasAastInterventionInError);

  page(
    '/pco-manager/aast/customers/:id/interventions',
    saasAastIntervention.byAastCustomer
  );
  page(
    '/pco-manager/aast/sites/:id/interventions',
    saasAastIntervention.byAastSite
  );

  page('/pco-manager/aast/customers/:id/cases', saasAastCustomerCaseList);
  page('/pco-manager/aast/sites/:id/cases', saasAastCustomerSiteList);

  page('/pco-manager/aast/stock', saasAastStock.bind);
  page('/pco-manager/aast/zones/:id/plan', saasAASTZones.edit);

  page('/pco-manager/aast/cases/:id/reports', saasAastCaseReports.bind);

  // Customer
  page('/customer/dashboard', customerDashboard.index);
  page('/customer/invoices', customerInvoices.list);
  page('/customer/reports', customerReports.list);
  page('/customer/documents', customerDocuments.list);
  page('/customer/aast-reports', customerAASTReports.list);

  page.start({
    click: false,
    popstate: false,
  });
}



// WEBPACK FOOTER //
// ./src/router.js